module.exports = __webpack_public_path__ + "static/media/03_newsize_ecsPlus_Line.31c164ba.jpg";